module.exports = __webpack_public_path__ + "img/left.4c2dcd24.png";